import { Injectable } from "@angular/core";
import { UtenteOperatoreVO } from "@app/shared/vo/utente-operatoreVO";
import { UtenteOperatoreDTO } from "@app/shared/dto/utente-operatoreDTO";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";

@Injectable()
export class MapperUtenteOperatore
  implements MapperInterface<UtenteOperatoreDTO, UtenteOperatoreVO> {
  convertVoToDto(e: UtenteOperatoreVO): UtenteOperatoreDTO {
    throw new Error("Method not implemented.");
  }
  convertDtoToVo(t: UtenteOperatoreDTO): UtenteOperatoreVO {
    const utenteOperatoreVO = new UtenteOperatoreVO();
    utenteOperatoreVO.cognome = t.cognome;
    utenteOperatoreVO.id = t.id;
    utenteOperatoreVO.nome = t.nome;
    utenteOperatoreVO.username = t.username;
    utenteOperatoreVO.ruoli = t.ruoli;
    return utenteOperatoreVO || new UtenteOperatoreVO();
  }
  convertListVoToDto(e: UtenteOperatoreVO[]): UtenteOperatoreDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(t: UtenteOperatoreDTO[]): UtenteOperatoreVO[] {
    throw new Error("Method not implemented.");
  }
}
